import React, { memo, useEffect, useState, useRef } from 'react'
import { useTheme } from '@material-ui/core/styles'
import { useDispatch, useSelector } from 'react-redux'

import {
  ArrowBackRounded as BackIcon,
  CloseRounded as CloseIcon,
  PlayArrowRounded as PlayIcon,
  PauseRounded as PauseIcon,
} from '@material-ui/icons'

import { setActiveConversation } from '../../../redux/activeConversation/actions'
import { setActiveAudio } from '../../../redux/activeAudio/actions'
import Avatar from '../../molecules/avatar/customer'
import IconButton from '../../atoms/inputs/iconButton'
import Typography from '../../atoms/display/typography'
import Slider from '../../atoms/feedback/slider'

import useStyles from './pipAudioStyle'

const pipAudio = (props) => {
  const dispatch = useDispatch()
  const classes = useStyles()
  const theme = useTheme()
  const activeConversation = useSelector((state) => state.activeConversation)
  const conversation = useSelector(
    (state) => state.conversations.conversations[activeConversation]
  )
  const activeAudio = useSelector((state) => state.activeAudio)
  const audioRef = useRef()
  const [playing, setPlaying] = useState(false)
  const [currentTime, setCurrentTime] = useState()
  const [currentTimeFormated, setCurrentTimeFormated] = useState('00:00')
  const [duration, setDuration] = useState()
  const [durationFormated, setDurationFormated] = useState('00:00')

  useEffect(() => {
    if (activeAudio?.track) {
      audioRef.current.currentTime = activeAudio.track
      playAudio()
    }
  }, [])

  const playAudio = () => {
    audioRef?.current?.play()
    setPlaying(true)
  }
  const pauseAudio = () => {
    audioRef?.current?.pause()
    setPlaying(false)
  }
  const updateTrack = (value) => {
    audioRef.current.currentTime = value
  }
  const onLoadAudio = () => {
    var duration = audioRef?.current?.duration
    if (duration != Infinity) {
      var s = parseInt(duration % 60)
      var m = parseInt((duration / 60) % 60)
      if (m < 10) m = '0' + m
      if (s < 10) s = '0' + s
      setDuration(duration)
      setDurationFormated(m + ':' + s)
    }
  }
  const onTimeUpdate = () => {
    var currentTime = audioRef?.current?.currentTime
    if (currentTime != Infinity) {
      var s = parseInt(currentTime % 60)
      var m = parseInt((currentTime / 60) % 60)
      if (m < 10) m = '0' + m
      if (s < 10) s = '0' + s
      dispatch(
        setActiveAudio({
          ...activeAudio,
          track: currentTime,
        })
      )
      setCurrentTime(currentTime)
      setCurrentTimeFormated(m + ':' + s)
    }
  }
  const onEndedAudio = () => {
    var currentTime = audioRef?.current?.currentTime
    if (currentTime != Infinity) {
      var s = parseInt(currentTime % 60)
      var m = parseInt((currentTime / 60) % 60)
      if (m < 10) m = '0' + m
      if (s < 10) s = '0' + s
      setPlaying(false)
      setDuration(currentTime)
      setDurationFormated(m + ':' + s)
    }
  }

  return (
    <>
      <div className={classes.root}>
        <div className={classes.content}>
          <div className={classes.header}>
            <div>
              <Avatar
                src={''}
                // activeConversation={activeAudio.activeConversation}
                name={conversation?.consumer?.name}
                conversationId={conversation?.conversationId}
                variant={true}
              />
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-end',
                  flexWrap: 'nowrap',
                }}
              ></div>
            </div>
            <div className={classes.headerControls}>
              <IconButton
                color="primary"
                onClick={() => {
                  dispatch(
                    setActiveConversation(activeAudio.activeConversation)
                  )
                }}
              >
                <BackIcon style={{ color: theme.palette.primary.main }} />
              </IconButton>
              <div style={{ width: 10 }} />
              <IconButton
                color="primary"
                onClick={() => {
                  dispatch(
                    setActiveAudio({
                      ...activeAudio,
                      play: false,
                    })
                  )
                }}
              >
                <CloseIcon style={{ color: theme.palette.primary.main }} />
              </IconButton>
            </div>
          </div>
          <div className={classes.player}>
            <audio
              ref={audioRef}
              onTimeUpdate={onTimeUpdate}
              onLoadedMetadata={onLoadAudio}
              onEnded={onEndedAudio}
              preload="auto"
            >
              <source src={activeAudio.src} type={activeAudio.type} />
            </audio>
            <Typography variant="h6">{currentTimeFormated}</Typography>
            <div style={{ width: 40 }} />
            <Slider
              min={0}
              value={currentTime}
              max={duration}
              onChange={(e, newValue) => {
                e.stopPropagation()
                updateTrack(newValue)
              }}
            />
            <div style={{ width: 40 }} />
            <Typography variant="h6">{durationFormated}</Typography>
            <div style={{ width: 40 }} />
            <IconButton
              color="primary"
              style={{ backgroundColor: theme.palette.primary.main }}
              onClick={() => {
                playing ? pauseAudio() : playAudio()
              }}
            >
              {playing ? (
                <PauseIcon style={{ color: '#fff' }} />
              ) : (
                <PlayIcon style={{ color: '#fff' }} />
              )}
            </IconButton>
          </div>
        </div>
      </div>
    </>
  )
}

export default memo(pipAudio)
